module.exports = __webpack_public_path__ + "img/apple-icon-precomposed.270f660e.png";